import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Adapter, ComponentAsync, LL_H_T, LL_V_L, Button, TS_Tree } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_FHIR.scss';
import { Example_ColorfulNodeRenderer } from '../../components/tree.js';
import { Patients_Sandbox } from './patients.js';
class Pg_Component extends ComponentAsync {
    render() {
        const adapter = new Adapter(this.state.output).setTreeNodeRenderer(Example_ColorfulNodeRenderer);
        return _jsxs(LL_H_T, { children: [_jsx(LL_V_L, { children: Patients_Sandbox.map(patient => _jsx(Button, { style: { background: 'red' }, onClick: async (e) => {
                            // const fhirResponse = await ModuleFE_FHIR.vv1.fetchFhir({
                            // 	session: {sessionId: 'test', sessionData: {patient_id: patient.patientFhirId, encounter_id: 'test'}},
                            // 	queryTemplate: FhirQuery_LabResults
                            // }).executeSync();
                            // this.logInfo(fhirResponse);
                        }, children: patient.name })) }), _jsx(TS_Tree, { adapter: adapter })] });
    }
}
export const PgDev_FHIRConsole = { name: 'FHIR Console', key: 'fhir-console', renderer: Pg_Component };
